import { formatDateValue } from "@common";

const EMPTY_VALUE = "";

const getValue = (value) =>
  value === null || value === undefined || value === ""
    ? EMPTY_VALUE
    : value;

const formatBoolean = (val) => {
  if (val === true || val === "true" || val === "Yes") return "Yes";
  if (val === false || val === "false" || val === "No") return "No";
  return EMPTY_VALUE;
};

export const getProspectContactBasicInfoView = (data = {}) => {
  const left = [
    {
      label: "Sl No",
      value: getValue(data?.slNo),
    },
    {
      label: "Title",
      value: getValue(
        typeof (data?.title) === "object"
          ? (data?.title)?.personTitle ||
          (data?.title)?.label ||
          (data?.title)?.name
          : (data?.title)
      ),
    },
    {
      label: "First Name",
      value: getValue(data?.firstName),
    },
    {
      label: "Middle Name",
      value: getValue(data?.middleName),
    },
    {
      label: "Last Name",
      value: getValue(data?.lastName),
    },
    {
      label: "Display Name",
      value: getValue(data?.displayName),
    },
    {
      label: "Department",
      value: getValue(
        typeof data?.department === "object"
          ? data?.department?.departmentName
          : data?.department
      ),
    },
    {
      label: "Is Active",
      value: formatBoolean(data?.isActive),
    },
  ];

  const right = [
    {
      label: "Status",
      value: getValue(
        typeof (data?.status ?? data?.contactStatus) === "object"
          ? (data?.status ?? data?.contactStatus)?.contactStatus || (data?.status ?? data?.contactStatus)?.name
          : (data?.status ?? data?.contactStatus)
      ),
    },
    {
      label: "Job Title",
      value: getValue(
        typeof data?.jobTitle === "object"
          ? data?.jobTitle?.jobTitle
          : data?.jobTitle
      ),
    },
    {
      label: "Contact Role",
      value: getValue(
        typeof data?.contactRole === "object"
          ? data?.contactRole?.roleName
          : data?.contactRole
      ),
    },
    {
      label: "Seniority Level",
      value: getValue(
        typeof data?.seniorityLevel === "object"
          ? data?.seniorityLevel?.seniorityLevelName
          : data?.seniorityLevel
      ),
    },
    {
      label: "Influence Level",
      value: getValue(
        typeof data?.influenceLevel === "object"
          ? data?.influenceLevel?.influenceLevelName
          : data?.influenceLevel
      ),
    },
    {
      label: "Converted At",
      value: formatDateValue(data?.convertedAt),
    },
    {
      label: "Is Primary",
      value: formatBoolean(data?.isPrimary),
    },
  ];

  const fullWidth = [
    {
      label: "Notes",
      value: getValue(data?.notes),
    },
  ];

  return {
    left,
    right,
    fullWidth,
  };
};
